'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _react2.default.createClass({
  displayName: 'TypographyStyle',

  propTypes: {
    typography: _react2.default.PropTypes.object.isRequired
  },

  render: function render() {
    return _react2.default.DOM.style({
      id: 'typography.js',
      dangerouslySetInnerHTML: {
        __html: this.props.typography.toString()
      }
    });
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-typography/dist/TypographyStyle.js
 ** module id = 1168
 ** module chunks = 0
 **/